import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import FooterGeneralLinks from './components/FooterGeneralLinks';
import FooterNav from './components/FooterNav';
import FooterSocialsAndDisclaimer from './components/FooterSocialsAndDisclaimer';
import styles from './FooterV2.module.css';

export const FooterV2 = () => {
  return (
    <footer className={styles.footerContainer} data-testid="footer-v2">
			<FooterNav />
			<FooterSocialsAndDisclaimer />
			<FooterGeneralLinks />
		</footer>);

};